// extracted by mini-css-extract-plugin
export default {"saleForm":"sale-form_saleForm__Vp8DC","form":"sale-form_form__+32+V","containerField":"sale-form_containerField__m6kAo"};